export default __webpack_public_path__ + "static/media/57_mobile.238a1b74.jpg";